import React from 'react';
import {AppText, AppBodyText} from '../../../../Presentation/components/ui/Typography';
import Button from '../../../../Presentation/components/ui/Button';
import {Badge} from '../../../../Presentation/components/ui/Badge';

interface PermissionActionsProps {
  selectedCount: number;
  totalCount: number;
  hasChanges: boolean;
  assigning: boolean;
  onCancel: () => void;
  onSave: () => void;
}

/**
 * Reusable component for permission actions
 */
export const PermissionActions: React.FC<PermissionActionsProps> = ({
  selectedCount,
  totalCount,
  hasChanges,
  assigning,
  onCancel,
  onSave
}) => {
  return (
    <div className="flex items-center justify-between pt-4 border-t">
      <div className="flex items-center space-x-2 space-x-reverse">
        <AppBodyText className="text-gray-600">
          {selectedCount} من {totalCount} صلاحية محددة
        </AppBodyText>
        {hasChanges && (
          <Badge variant="warning" className="text-xs">
            تغييرات غير محفوظة
          </Badge>
        )}
      </div>

      <div className="flex items-center space-x-3 space-x-reverse">
        <Button
          variant="outline"
          onClick={onCancel}
          disabled={assigning}
        >
          إلغاء
        </Button>
        <Button
          onClick={onSave}
          disabled={assigning || !hasChanges}
          isLoading={assigning}
        >
          حفظ التغييرات
        </Button>
      </div>
    </div>
  );
};
